import React, { Component } from "react";
import { FRONTM_DOMAIN, HELPER_MESSAGE, ISLE_OF_MAN_LANDING, ONSHIP_LANDING } from '../../Utils/Constants';
import Config from '../../Utils/Config';
import { activateEnterpriseBots } from '../../Services/BotsService';
import { updateLastLoggedInDomain } from '../../Services/UserService';
import { loadAllDomainsListInLFStorage } from '../../Services/LFStorage';

const R = require("ramda");

class GoogleLoginButton extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	// commented this and handled with error boundaries
	// startLogin = () => {
	// 	this.props.clearLoginError();
	// 	window.auth2
	// 		.grantOfflineAccess({
	// 			scope: "profile email",
	// 		})
	// 		.then(this.onSignIn);
	// };

	startLogin = async () => {
		try {
			this.props.clearLoginError();

			const result = await window.auth2.grantOfflineAccess({
				scope: "profile email",
			});
			console.info("Google login successfull");
			this.onSignIn(result);
		} catch (err) {
			console.error("Google Login failed with error : ", err);
		}
	};
	onSignIn = (code) => {
		this.props.doGoogleAuth(code.code, this.props.onLogin);
	};

	render() {
		let landingPath = this.props.landingPath;
		return (
			<div>
				{[ONSHIP_LANDING, ISLE_OF_MAN_LANDING].includes(landingPath) ? (
					<a
						onClick={this.startLogin}
						className="d-block rounded si-colored-g-plus mb-2"
					>
						<img
							src="/img/GoogleButtonWideWidth.png"
							alt=""
							className="socialLogin-btn-wide"
							// style={{ width: "250px", height: "40px" }}
						/>
					</a>
				) : (
					<a
						onClick={this.startLogin}
						className="d-block rounded si-colored-g-plus mb-2"
					>
						<img
							src="/img/btn-google@2x.png"
							alt=""
							className="socialLogin-btn"
							// style={{ width: "250px", height: "40px" }}
						/>
					</a>
				)}
			</div>
		);
	}
}

export default GoogleLoginButton;
// w - 255 , h - 33
